import { defineComponent as _defineComponent } from 'vue'
import { useLanguageStore } from '@/helpers/composables/useStores';
import { getShortMonthName } from '@/helpers/date-helper';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarIcon',
  setup(__props) {

const { locale } = useLanguageStore();

const month = computed(() => getShortMonthName(new Date(), locale.value.replace('_', '-')));

const date = computed(() => new Date().getDate());

return { __sfc: true,locale, month, date }
}

})